import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/api';

// Axios-Instanz mit Auth-Header
const api = axios.create({
  baseURL: API_URL
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const firmendatenApi = {
  // Firmendaten laden (mit Auth)
  get: async () => {
    const response = await api.get('/firmendaten');
    return response.data;
  },

  // Öffentliche Firmendaten laden (ohne Auth) - für Header etc.
  getPublic: async () => {
    const response = await axios.get(`${API_URL}/firmendaten/public`);
    return response.data;
  },

  // Firmendaten speichern/aktualisieren
  update: async (data) => {
    const response = await api.put('/firmendaten', data);
    return response.data;
  },

  // Auf Standardwerte zurücksetzen
  reset: async () => {
    const response = await api.post('/firmendaten/reset');
    return response.data;
  }
};
